import Link from "next/link"

export function NavLink({
  href,
  children
}: {
  href: string
  children: string
}) {
  return (
    <Link
      href={href}
      className="inline-block rounded-lg px-2 py-1 text-sm text-gray-400 transition-colors hover:bg-white/5 hover:text-gray-100"
    >
      {children}
    </Link>
  )
}
